<template>
 <div style="padding: 20px;text-align:left;">
    <h1 id="declaracion-manual-js">Declaración de Accesibilidad</h1>
 
    <!-- Sustituir AAA por la url del sitio web -->
    <article id="introduccion">
      <p>
        El
        <a
          href="https://www.um.es/web/atica/accesibilidad"
          target="_blank"
          rel="noopener noreferrer"
          title="Área de Tecnologías de la Información y las Comunicaciones Aplicadas (ATICA) de la Universidad de Murcia (Abre en nueva ventana)"
          >Área de Tecnologías de la Información y las Comunicaciones Aplicadas (ATICA) de la Universidad de Murcia</a
        >
        se ha comprometido a hacer accesibles sus sitios web de conformidad con el
        <a
          href="https://www.boe.es/diario_boe/txt.php?id=BOE-A-2018-12699"
          target="_blank"
          rel="noopener noreferrer"
          title="Real Decreto 1112/2018, de 7 de septiembre, sobre accesibilidad de los sitios web y aplicaciones para dispositivos móviles del sector público (Abre en nueva ventana)"
          >Real Decreto 1112/2018, de 7 de septiembre, sobre accesibilidad de los sitios web y aplicaciones para dispositivos móviles del sector público</a
        >.
      </p>
      <p>La presente declaración de accesibilidad se aplica al sitio web <a href="https://secretariacursos.um.es">https://secretariacursos.um.es</a> y a <a :href="urlWeb" :title="urlWeb">{{ urlWeb }}</a>.</p>
    </article>
 
    <!-- Caso A: conformidad total (comentar este article si no es el caso) -->
    <!-- En este caso, la Comisión Europea recomienda incluir un enlace al Informe de evaluación que avale dicho nivel de conformidad en el apartado de "Contenido opcional". -->
    <article id="situacionCumplimientoA" v-if="situacionCumplimiento == 'A'">
      <h2>Situación de cumplimiento</h2>
      <p>Este sitio web es <strong>plenamente conforme</strong> con el RD 1112/2018.</p>
    </article>
 
    <!-- Caso B: conformidad parcial -->
    <article id="situacionCumplimientoB" v-else-if="situacionCumplimiento == 'B'">
      <h2>Situación de cumplimiento</h2>
      <p>Este sitio web es <strong>parcialmente conforme</strong> con el RD 1112/2018 debido a las excepciones y a la falta de conformidad de los aspectos que se indican a continuación.</p>
    </article>
 
    <!-- Caso C: no conformidad -->
    <article id="situacionCumplimientoC" v-else-if="situacionCumplimiento == 'C'">
      <h2>Situación de cumplimiento</h2>
      <p>Este sitio web aún <strong>no es conforme</strong> con el RD 1112/2018. A continuación, se indican las excepciones y los aspectos no conformes.</p>
    </article>
 
    <!-- Caso B o C (comentar este article si hay conformidad total) -->
    <article id="contenidoNoAccesible">
      <h2>Contenido no accesible</h2>
      <p>El contenido que se recoge a continuación no es accesible por lo siguiente:</p>
      <ol>
        <li>
          <p><strong>falta de conformidad con el RD 1112/2018</strong></p>
          <ul>
            <li>
              <p>
                Podrían existir fallos puntuales de edición en alguna página web, tanto en contenidos HMTL como en documentos finales, publicados en fecha <strong>posterior</strong> al 20 de
                septiembre de 2018.
              </p>
            </li>
            <li>
				<p>Hay componentes de la interfaz de usuario con etiquetas que incluyen texto, o imágenes de texto, el nombre no contiene el texto que se presenta visualmente.
				</p>
            </li>
          </ul>
        </li>
        <li>
          <p><strong>carga desproporcionada</strong></p>
          <ul>
            <li><p>No aplica.</p></li>
          </ul>
        </li>
        <li>
          <p>el contenido <strong>no entra dentro del ámbito de la legislación</strong> aplicable</p>
          <ul>
            <li>
              <p>
                Podrían existir archivos ofimáticos en PDF u otros formatos publicados <strong>antes</strong> del 20 de septiembre de 2018 que no cumplan en su totalidad todos los requisitos de
                accesibilidad.
              </p>
            </li>
          </ul>
        </li>
      </ol>
    </article>
 
    <!-- Sustituir BBB por la fecha en la que la declaración de accesibilidad se preparó por primera vez tras una evaluación de la accesibilidad de los sitios web o aplicaciones para dispositivos móviles a los que aplica. -->
    <!-- Sustituir CCC por la fecha en la que se actualizó la declaración, fruto de una nueva evaluación de accesibilidad tras una revisión sustancial del sitio web o aplicación para dispositivos móviles. -->
    <!-- Como mínimo se debe hacer una "evaluación de la accesibilidad" cada 3 años, por tanto, la fecha de preparación no puede superar en más de 3 años la fecha actual. Cada vez que se realiza una "evaluación de la accesibilidad" hay que actualizar la fecha de preparación y también la fecha de última revisión. Como máximo se debe hacer una "revisión de la exactitud de la declaración de accesibilidad" cada año. Cuando se realice esta revisión solo debe modificarse la fecha de última revisión. -->
    <article id="preparacion">
      <h2>Preparación de la presente declaración de accesibilidad</h2>
      <p>La presente declaración fue preparada el {{ fechaInicialDeclaracion }}.</p>
      <p>El método empleado para preparar la declaración ha sido una autoevaluación llevada a cabo por el propio organismo.</p>
      <p>Última revisión de la declaración el {{ fechaActualizacionDeclaracion }}.</p>
    </article>
 
    <article id="observacionesContacto">
      <h2>Observaciones y datos de contacto</h2>
      <p>Puede realizar <strong>comunicaciones</strong> sobre requisitos de accesibilidad (artículo 10.2.a) del RD 1112/2018) como por ejemplo:</p>
      <ul>
        <li>informar sobre cualquier posible <strong>incumplimiento</strong> por parte de este sitio web</li>
        <li>transmitir otras <strong>dificultades de acceso</strong> al contenido</li>
        <li>formular cualquier otra <strong>consulta o sugerencia de mejora</strong> relativa a la accesibilidad del sitio web</li>
      </ul>
      <p>A través de las siguientes vías:</p>
      <ul>
        <li>Aplicación web: <a href="http://dumbo.um.es" title="http://dumbo.um.es (Abre en nueva ventana)" target="_blank" rel="noopener noreferrer">http://dumbo.um.es</a></li>
        <li>Correo electrónico: <a href="mailto:dumbo@um.es" title="dumbo@um.es">dumbo@um.es</a></li>
        <li>Teléfono: 868 88 42 22</li>
      </ul>
      <p>Puede presentar:</p>
      <ul>
        <li>una <strong>Queja</strong> relativa al cumplimiento de los requisitos del RD 1112/2018 o</li>
        <li>
          una <strong>Solicitud de Información accesible</strong> relativa a:
          <ul>
            <li><strong>contenidos</strong> que están <strong>excluidos</strong> del <strong>ámbito de aplicación</strong> del RD 1112/2018 según lo establecido por el artículo 3, apartado 4</li>
            <li>
              <strong>contenidos</strong> que están <strong>exentos</strong> del <strong>cumplimiento</strong> de los requisitos de accesibilidad por imponer una
              <strong>carga desproporcionada</strong>.
            </li>
          </ul>
        </li>
      </ul>
      <p>En la Solicitud de información accesible, se debe concretar, con toda claridad, los hechos, razones y petición que permitan constatar que se trata de una solicitud razonable y legítima.</p>
      <p>
        A través del
        <a
          href="https://sede.um.es/registro2/PR-000179"
          target="_blank"
          rel="noopener noreferrer"
          title="Procedimiento de solicitud de información y quejas sobre accesibilidad de la Sede electrónica de la Universidad de Murcia (Abre en nueva ventana)"
          >Procedimiento de solicitud de información y quejas sobre accesibilidad de la Sede electrónica de la Universidad de Murcia</a
        >, así como del resto de opciones recogidas en la Ley 39/2015, de 1 de octubre, del Procedimiento Administrativo Común de las Administraciones Públicas.
      </p>
      <p>
        Las comunicaciones, quejas y solicitudes de información accesible serán recibidas y tratadas por el
        <strong
          ><a
            href="https://www.um.es/web/atica/accesibilidad"
            target="_blank"
            rel="noopener noreferrer"
            title="Área de Tecnologías de la Información y las Comunicaciones Aplicadas (ATICA) de la Universidad de Murcia (Abre en nueva ventana)"
            >Área de Tecnologías de la Información y las Comunicaciones Aplicadas (ATICA) de la Universidad de Murcia</a
          ></strong
        >.
      </p>
    </article>
 
    <article id="procedimientoAplicacion">
      <h2>Procedimiento de aplicación</h2>
      <p>
        Si una vez realizada una solicitud de información accesible o queja, ésta hubiera sido desestimada, no se estuviera de acuerdo con la decisión adoptada, o la respuesta no cumpliera los
        requisitos contemplados en el artículo 12.5, la persona interesada podrá iniciar una reclamación. Igualmente se podrá iniciar una reclamación en el caso de que haya trascurrido el plazo de
        veinte días hábiles sin haber obtenido respuesta.
      </p>
      <p>
        La reclamación puede ser presentada través del
        <a
          href="https://sede.um.es/registro2/PR-000179"
          target="_blank"
          rel="noopener noreferrer"
          title="Procedimiento de solicitud de información y quejas sobre accesibilidad de la Sede electrónica de la Universidad de Murcia (Abre en nueva ventana)"
          >Procedimiento de solicitud de información y quejas sobre accesibilidad de la Sede electrónica de la Universidad de Murcia</a
        >, así como del resto de opciones recogidas en la Ley 39/2015, de 1 de octubre, del Procedimiento Administrativo Común de las Administraciones Públicas.
      </p>
      <p>Las reclamaciones serán recibidas y tratadas por la <strong>Secretaria General de la Universidad de Murcia</strong>.</p>
    </article>
 
    <!-- Descomentar este article si se quiere añadir contenido opcional -->
    <!-- El contenido opcional que se indica a continuación puede añadirse a la declaración de accesibilidad según se estime oportuno: -->
    <!--     1) una explicación del compromiso del organismo del sector público con la accesibilidad digital, por ejemplo: -->
    <!--         · su intención de alcanzar un mayor grado de accesibilidad que el exigido por la legislación, -->
    <!--         · las medidas correctoras que se adoptarán para hacer accesible el contenido de los sitios web y las aplicaciones para dispositivos móviles que no sea accesible, incluido el calendario para la aplicación de tales medidas; -->
    <!--     2) respaldo oficial (en la esfera administrativa o política) a la declaración de accesibilidad; -->
    <!--     3) fecha de publicación del sitio web o la aplicación para dispositivos móviles; -->
    <!--     4) fecha de la última actualización del sitio web o la aplicación para dispositivos móviles tras una revisión sustancial del contenido; -->
    <!--     5) enlace a un informe de evaluación, si se dispone de él, y en particular si se ha indicado que el sitio web o la aplicación para dispositivos móviles es «a) plenamente conforme»; -->
    <!--     6) asistencia telefónica adicional para las personas con discapacidad y ayuda para los usuarios de tecnologías de apoyo; -->
    <!--     7) cualquier otra información que se considere apropiada. -->
    <article id="contenidoOpcional">
      <!--     <h2>Contenido opcional</h2> -->
    </article>
  </div>
</template>
 
<script>
import store from "../store";

export default {
    data() {
        return {
            // "A" si se cumplen todos los requisitos, "B" si se cumple la mayoría, "C" si no se cumple la mayoría
            situacionCumplimiento: "B",
            // Url del sitio web
            urlWeb: store.getters["token/urlLogin"],
            // Fecha en la que la declaración de accesibilidad se preparó por primera vez tras una evaluación de la accesibilidad
            fechaInicialDeclaracion: "27/07/2021",
            // Fecha en la que se actualizó la declaración
            fechaActualizacionDeclaracion: "29/10/2021",
        }
    },
};
</script>